import type { FieldSchemaModel } from '@/shared/generated'

const PREPRO_STAGES = ['prepro', 'pre_init_fields']
// Anchoring runs before repricing, so pricing_campaign/reprice/final_fields columns are not computed yet.
const ANCHOR_STAGES = [...PREPRO_STAGES, 'init_fields']

// `stage` is optional in the payload; the API default is `prepro`.
const getStage = (field: FieldSchemaModel) => field.config?.stage ?? 'prepro'

export const isPreproField = (field: FieldSchemaModel) =>
	PREPRO_STAGES.includes(getStage(field))

export const isAnchorStageField = (field: FieldSchemaModel) =>
	ANCHOR_STAGES.includes(getStage(field))

export const isFilterbaleField = (field: Pick<FieldSchemaModel, 'params'>) =>
	field.params.filterable
